import React, {createRef, useEffect, useState} from 'react';
import moment from "moment";
import __ from "lodash";
import { v4 as uuidv4 } from 'uuid';
import {Grid, InputLabel} from "@material-ui/core";

import {DropzoneMultiFileUpload, FormDialog, Text} from "../../../controls";
import FlightDocumentsGrid from "./FlightDocumentsGrid";
//import Validator from "../../validators/EditCrewValidator";

const dateFormat = "DD/MM/YYYY";

const EditFlightDocumentsDialog = (props) => {
  const classes = props.classes;
  const canEdit = props.canEdit;
  const SystemData = props.systemData;
  const eventBus = SystemData.eventBus;
  const handleUpdate = props.handleUpdateFlight;
  const extraKeys = props.extraKeys;
  const eventPrefix = props.eventPrefix || "EditFlightDocuments";

  const [dialogStates, setDialogStates] = useState({
    showDialog: false,
    record: {},
    title: 'Flight Documents',
  });
  const [documentsGridApi, setDocumentsGridApi] = useState(null);

  useEffect(()=> {
    const open = async (record, updateKeys) => {
      if (!__.has(record, "documents") || !Array.isArray(record.documents) || record.documents.length < 1) {
        const emptyDocument =
          {
            id: uuidv4(),
            sequence: 1,
            documentType: "OTHER",
            fileDescription: "",
            fileType: "",
            fileSize: "",
            fileName: "",
            deleteAction: "",
            fileUrl: "",
          };
        record["documents"] = [emptyDocument];
      }
      setDialogStates({...dialogStates, showDialog:true, record: __.cloneDeep(record) });
    }

    eventBus.bind(`${eventPrefix}.open`, open);

    return () => {
      eventBus.unbind(`${eventPrefix}.open`, open);
    }
  }, [dialogStates, eventBus, eventPrefix]);

  const handleAddFunction = () => {
    if (eventBus) {
      eventBus.trigger('Document.AddFunction');
    }
  }

  if (dialogStates.showDialog) {
    return (
      <FormDialog
        title={dialogStates.title}
        message=""
        open={dialogStates.showDialog}
        record={dialogStates.record}
        dialogOptions={{width: "lg", maxWidth: "lg", fullWidth: true,  height: "inherit"}}
        classes={classes}
        //validator={Validator}
        buttons = {canEdit ? {
          // addFunction: {icon: "add_circle", key: "Add Function", label: "Add Function", color: "primary"},
          save:{icon: "check_circle", key: "Save", label: "Save", color: "primary", disabled: (status)=>{return status.error}},
          cancel:{icon: "cancel", key: "Cancel", label: "Close", color: "primary"}
        }: {
          cancel:{icon: "cancel", key: "Cancel", label: "Close", color: "primary"}
        }}
        onChange={(state) => {
          if (state.buttonPressed === "save") {
            const record = state.record;
            const documents = record.documents;
            if (Array.isArray(documents) && documents.length === 1) {
              const document = documents[0];
              const docFields = `${document.fileDescription}${document.fileType}${document.fileSize}${document.fileName}${document.fileUrl}`;
              if (docFields.length < 1)
                record["documents"] = null;
            }
            handleUpdate.mutate({
              extraKeys: extraKeys,
              record,
              postSuccess: () => {
                setDialogStates({...dialogStates, showDialog: false, record: null});
                if (props.afterSave) {
                  props.afterSave();
                }
              },
              postError: (data) => {
                if (props.onError) {
                  props.onError(data);
                } else if (data.errorMessage) {
                  SystemData.alert("Error", `${data.errorMessage}`);
                } else {
                  SystemData.alert("Error", `An Unexpected Error has occurred.`);
                }
              }
            });
          } else if (state.buttonPressed === "addFunction" && canEdit) {
            handleAddFunction();
          } else {
            setDialogStates({...dialogStates, showDialog: false, record: null});
          }
        }}

      >
        <Grid container checkChildren={true} spacing={1}>
          <Grid item xs={1} checkChildren={true}>
            {(record, changeRecord) => (
              <div>
                <InputLabel shrink>
                  Flight
                </InputLabel>

                <Text
                  style={{width: "100%", marginTop: 2, display: "inline-block"}}
                  defaultValue={`${record.airlineCode}-${record.flightNo}`}
                />
              </div>
            )}
          </Grid>

          <Grid item xs={1} checkChildren={true}>
            {(record, changeRecord) => (
              <div>
                <InputLabel shrink>
                  Flight Date
                </InputLabel>

                <Text
                  style={{width: "100%", marginTop: 2, display: "inline-block"}}
                  defaultValue={`${moment(record.flightDate, "YYYY-MM-DD HH:mm:ss").format(dateFormat)}`}
                />
              </div>
            )}
          </Grid>

          <Grid item xs={2} checkChildren={true}>
            {(record, changeRecord) => (
              <div>
                <InputLabel shrink>
                  Trip Number
                </InputLabel>

                <Text
                  style={{width: "100%", marginTop: 2, display: "inline-block"}}
                  defaultValue={`${record.tripPrefix}${record.tripNo}`}
                />
              </div>
            )}
          </Grid>

          <Grid item xs={3} checkChildren={true}>
            {(record, changeRecord) => (
              <div className="d-flex flex-row justify-content-between align-items-center">
                <InputLabel shrink>
                  Route
                </InputLabel>

                <Text
                  style={{width: "100%", marginTop: 2, display: "inline-block"}}
                  defaultValue={`${record.originAirportCode} -> ${record.destinationAirportCode}`}
                />
              </div>
            )}
          </Grid>

          {canEdit?
          <Grid item xs={5} checkChildren={true}>
            {(record, changeRecord) => (

              <div className="d-flex flex-row justify-content-between align-items-center">
                <InputLabel shrink>
                  Bulk Document Upload
                </InputLabel>

                <DropzoneMultiFileUpload
                  objectType="FLIGHT"
                  tripLegUuid={record.tripLegUuid}
                  documentUuid={" "}
                  accept=".doc, .docx, .xls, .xlsx, .pdf, .rtf"
                  dropzoneStyle={{ height: 50,  maxHeight: 50, minHeight: 50, border: "1px dashed #929292" }}
                  inputLabel={{fontSize: 17, color: "#fd5b02"}}
                  inputContent={"Drop a set of files or Click to browse"}
                  disabled={false}
                  onChange={(result, props)=>{
                    if (result && result.status) {
                      const fileType = result.fileName.split('.');
                      const fileSize = result.fileSize > 1000000
                        ? `${(result.fileSize / 1000000).toFixed(0)}MB`
                        : result.fileSize > 1000
                          ? `${(result.fileSize / 1000).toFixed(0)}KB`
                          : `${result.fileSize}B`
                      const newDocument = {
                        sequence: record.documents ? record.documents?.length + 1 : 1,
                        deleteAction: "",
                        documentType: "OTHER",
                        fileDescription: "",
                        fileName: result.fileName,
                        fileSize: fileSize,
                        fileType: Array.isArray(fileType) && fileType.length > 1 ? fileType[fileType.length - 1] : "",
                        fileUrl: result.url,
                        id: uuidv4(),
                      };
                      let documents = record.documents;
                      if (documents && Array.isArray(documents)) {
                        __.remove(documents, (o) => {return (o.fileName === "" && o.fileUrl === "" && o.fileSize === "")});
                      }
                      documents.push(newDocument);
                      props.recordChange({...props.record, documents: documents});
                      setDialogStates({...dialogStates, showDialog: false, record: {...props.record, documents: documents} });
                      if (documentsGridApi) {
                        setTimeout(function() {
                          //documentsGridApi.redrawRows();
                          setDialogStates({...dialogStates, showDialog: true });
                        }, 500);
                      }
                    }
                  }}
                />
              </div>
            )}
          </Grid>
          :
          <></>
          }

        </Grid>

        <Grid container checkChildren={true} spacing={3}>
          <Grid item xs={12} checkChildren={true}>
            {(record, changeRecord) => (
              <FlightDocumentsGrid
                id="documentsGrid"
                tripLegUuid={record.tripLegUuid}
                flightNumber={`${record.airlineCode}${record.flightNo}`}
                documents={typeof props.documentFilter === "function"?props.documentFilter(record.documents):record.documents}
                height={300}
                canEdit={canEdit}
                SystemData={SystemData}
                onGridReady={params => {
                  setDocumentsGridApi(params.api);
                }}
                onChange={(documents, props) => {
                  if (documents) {
                    const data = {
                      ...props.record,
                      documents: documents,
                    }
                    props.recordChange(data);
                  }
                }}
              />
            )}
            </Grid>
        </Grid>
      </FormDialog>
    )
  } else {
    return (<></>);
  }
}

export default EditFlightDocumentsDialog;
